import React from 'react';
import {
    Typography,
    Divider,
    Button,
    Card,
} from '@mui/material';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import ShareIcon from '@mui/icons-material/Share';
import CardMedia from '@mui/material/CardMedia';
import A8AdEFEnglish from '../../components/A8/A8AdEFEnglish';
import CATEGORY_IMAGE from '../../../static/biz-professional/fireworks-8182800_1280.jpeg';
import stock_chart from '../../../static/biz-professional/chart-1905225_1280.jpg';
import social_media from '../../../static/biz-professional/social-media-1795578_1280.jpg';
import { useNavigate } from 'react-router-dom';
import GL_IMAGE from '../../../static/biz-professional/GalleryLambda-Slide-Color.png';
import GL_IMAGE2 from '../../../static/biz-professional/GalleryLambda-Slide-Line.png';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';

interface ArticlePageProps {
    path: string;
}


const Article: React.FC<ArticlePageProps> = ({ path }) => {
    const handleCopyClick = () => {
        navigator.clipboard.writeText(path)
            .then(() => {
                console.log('Link copied to clipboard!');
            })
            .catch((err) => {
                console.error('Unable to copy link to clipboard', err);
            });
    };

    const navigate = useNavigate()
    const handleImageClick = (path: string) => {
        navigate(path);
        window.scrollTo(0, 0);
    };
    return (
        <div>
            <Box sx={{ mt: 7, mb: 12, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                <Card elevation={0} sx={{ maxWidth: 1000 }} style={{ margin: '0px', padding: '5px' }}>
                    <CardContent>
                        <Typography variant="h1" id="introduction" style={{ fontSize: '30px' }}>
                            第4回: デザインの話。色は情報である。そして線も情報である。
                        </Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="body2" color="text.primary">
                            Published on 2024 Jan 17th <br />
                            10 min read  <br />
                            by Michelle
                        </Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5">
                            これまで3回に渡り、プレゼンテーションのフォーマットや大事な考え方を説明してきました。プレゼンテーションにおけるイシュー、スライドの構成要素、メッセージの重要性、
                            みなさんはすでにこれらを理解していると思います。第4回では、デザインについて触れていきます。<br /><br />

                            とは言っても、プレゼンのデザインは会社によってある程度指定されていることも多いでしょうし、
                            また、クールなデザインのダウンロードも容易な世の中です。ですから、今日はデザインについて知っていてほしい最低限のルールを紹介したいと思います。私が戦略コンサルタントとして働いていた際にも
                            上司に何度も言われた観点です。
                        </Typography>
                    </CardContent>
                    <CardContent>
                        <Button variant="text" size="small" endIcon={<ShareIcon />} style={{ color: 'black' }} onClick={handleCopyClick}>
                            Copy URL of this ariticle
                        </Button>
                    </CardContent>
                    <CardMedia
                        component="img"
                        height="500"
                        sx={{

                            objectFit: 'cover',
                            filter: 'grayscale(90%)',
                        }}
                        image={CATEGORY_IMAGE}
                        alt="image of the category"
                    />
                    <CardContent>
                        <Typography variant="body2" color="text.secondary">
                            デザインの話。色は情報である。そして線も情報である。
                        </Typography>
                    </CardContent>
                    <Divider style={{ margin: '20px 0' }} />
                    <CardContent>
                        <Typography variant="h4" style={{ fontSize: '30px', fontWeight: 'lighter' }}>Table of Contents</Typography>
                    </CardContent>
                    <ol>
                        <li><a href="#1">色は情報である。</a></li>
                        <li><a href="#2">線も情報である。</a></li>
                        <li><a href="#3">最後に一言。</a></li>
                    </ol>
                    <Divider id="1" style={{ margin: '40px 0' }} />
                    <CardContent>
                        <Typography variant="h4" style={{ fontSize: '30px' }}>色は情報である。</Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5">
                            当然ですが質問です。みなさんにとって、赤と緑のイメージってそれぞれなんでしょうか。
                            下記のグラフはよくみるファイナンス関連のグラフですが、実際、ファイナンスの世界においては、赤は株価が下がったとき、緑は株価が上がったとき、という色使いがなされています。<br /><br />

                            転じて、ビジネスの世界においては赤はネガティブな強調。緑はポジティブな強調と言われることが多いです。あくまでも多いというだけであって明確なルールがあるわけではないのですが。

                            <br />
                            <br />
                            <blockquote>
                                <CardMedia
                                    component="img"
                                    sx={{

                                        objectFit: 'cover',
                                        filter: "grayscale(70%)"
                                    }}
                                    image={stock_chart}
                                    alt="image of the category"
                                />
                                <CardContent>
                                    <Typography variant="body2" color="text.secondary">
                                        出典:METI <a href="https://www.meti.go.jp/shingikai/enecho/shigen_nenryo/sekiyu_gas/pdf/001_04_00.pdf" target="_blank" rel="noopener noreferrer"> meti.go.jp </a> (p7)
                                    </Typography>
                                </CardContent>
                            </blockquote>

                            <br />
                            色使いに関して、まずは一つ目のルールです。<br /><br />
                            ルール1 - （ビジネスの場においては）赤はネガティブな強調、緑はポジティブな強調、そして、単に強調したいときはその他の色（青やネイビーなど）が一般的<br /><br />

                            とはいえ、色って人それぞれ違ったイメージがありますよね。なので究極的にはルール1を無視してもらっても大丈夫です。コーポレートカラーとの兼ね合いで、
                            緑主体のスライドテンプレートの場合もあるでしょうし、赤主体の場合だって考えられるからです。大事なことは、プレゼンテーションという文脈において、「色は情報である」ということです。<br /><br />

                            ルール2 - （色は情報ゆえ）異なる色を使う場合は、（可能な限り少ない色で）同系色に統一する。<br /><br />

                            それが意味するところを実例を見ながら説明いきましょう。


                            <br />
                            <br />

                            <CardMedia
                                component="img"
                                sx={{
                                    objectFit: 'cover',
                                }}
                                image={GL_IMAGE}
                                alt="image of the category"
                            />
                            <br />

                            左側の図は、正解例の一つです。グラフの各ラベルが同系色で統一されています。一方で、右側の図は、一般的には不正解です。何故なら、赤のラベルが不必要に強調されてしまっているからです。（勿論、それが意図した効果であれば別ですが。）
                            改めて、ルール2を再掲します。<br /><br />

                            ルール2 - （色は情報ゆえ）異なる色を使う場合は、（可能な限り少ない色で）同系色に統一する。<br /><br />

                            ダウンロードしてきたプレゼンテンプレートなどを含め、黄色や赤、緑など複数の色を使ったプレゼンテーション資料をよく見ますが、色の多用は御法度です。プロダクトロードマップなどでカテゴリごとに色付けしている図など、よく見るのではないでしょうか。
                            今後は同系色の違う濃さの色を使う。是非覚えておいてください。会社の経営層の中には外資系コンサルティングファームや投資銀行など、所謂プロフェッショナルファーム出身の方が一定数いるかと思いますが、色が少ないだけでよい印象を与えるのは事実です。（所詮、色ですが、色による印象操作は強烈です。）<br /><br />

                            実は、（私がまだ若かった時の話ですが）私自身も苦い経験があります。とある大企業の社長へのプレゼンをしたときのことです。キースライドの中で一つだけ色が違う部分があったのです。確かに少しだけ目立たせたいという意図はありましたが、とはいえスライドの中で一番目立たせたいわけではありませんでした。
                            すると実際にプレゼンをした際に、そこの部分に質問が集中したのです。本当はもっと議論すべき論点がありました。限られた時間の中でディスカッションのトピックの選定・誘導に失敗したのはプロとしては失格でしょう。
                            （勿論、そこに質問が集中したことが、色が違ったからなのかは本当のところわかりませんが、ものすごく悔やんだことを覚えています。）<br /><br />


                            <CardContent>
                                <TipsAndUpdatesIcon /> ここで、戦略コンサルティングファームであるArthur D. Littleの公開資料のリンクを下記にご紹介します。P32ページに、青系の異なる濃さの色で表現された綺麗なグラフがありますね。
                                <blockquote>
                                    <Typography variant="body2" color="text.secondary">
                                        出典:METI <a href="https://www.meti.go.jp/meti_lib/report/2020FY/000368.pdf" target="_blank" rel="noopener noreferrer"> meti.go.jp </a> (p32) - Arthur D. Little
                                    </Typography>
                                </blockquote>
                            </CardContent>

                        </Typography>
                    </CardContent>



                    <Divider id="2" style={{ margin: '40px 0' }} />
                    <CardContent>
                        <Typography variant="h4" style={{ fontSize: '30px' }}>線も情報である。</Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5">
                            唐突ですが、10年前のアイフォンアプリのアイコンを覚えていますか? アイコンには枠線や影がありましたよね。<br /><br />
                            一方で、昨今のアイコンには枠線や影がありません。2010年前後に台頭したフラットデザインの考え方が現在広く普及したからです。
                            フラットデザインとは、その言葉の通りではありますが、立体感や奥行きがなくフラットなデザインを指します。<br /><br />

                            語弊を恐れず、他の言い方をすると、2次元でモノを表現する際に限りなくシンプルに表現するデザインです。下記のアイコンは最近のものですが、
                            非常にシンプルですよね。

                            <br />
                            <br />
                            <blockquote>
                                <CardMedia
                                    component="img"
                                    sx={{

                                        objectFit: 'cover',
                                        filter: "grayscale(80%)"
                                    }}
                                    image={social_media}
                                    alt="image of the category"
                                />
                                <CardContent>
                                    <Typography variant="body2" color="text.secondary">
                                        線は情報である
                                    </Typography>
                                </CardContent>
                            </blockquote>

                            なお余談ですが、フラットデザインが何故普及したかには諸説ありますが、フラットデザインの台頭は、複数のデバイス（携帯電話、アイパッド、パソコン）に
                            対応し易かったことが主たる理由のようで、必ずしもそのデザイン性が理由ではないようです。<br /><br />

                            余談はさておき、フラットデザインはプレゼンテーションにおいても非常に有効です。何故なら、プレゼンテーションでは伝えるべき情報をシンプルにすべきだからです。
                            ここでも、実例を見ながら説明していきます。
                            <br />
                            <br />

                            <CardMedia
                                component="img"
                                sx={{

                                    objectFit: 'cover',
                                }}
                                image={GL_IMAGE2}
                                alt="image of the category"
                            />
                            <br /><br />

                            なお、色使いはプレゼンの成功に直接的に関わるものですが
                            （何故なら、色によって強調すべきところとそうでないところを操作でき、本当に伝えたいメッセージを印象付けることができるため）
                            正直なところ、フラットデザインに関しては、あくまでもデザイン的な趣味趣向が伴う部分なので、プレゼンの成功に直接紐づくかと言われると微妙なところです。とはいうものの、すっきりとしたモダンな印象づけはできるので、実践して損はないでしょう。<br /><br />

                            私が戦略コンサルティングファームに所属していた際に言われて納得した一言を紹介しておきます。「線をつけることで何かしらの意図があるなら（境目を強調したい、など）つけてもいいが、意図がないなら線はいらない。だって不要な情報を付与するだけだから。」<br /><br />

                            デザインも突き詰めて考えると、ロジカルに考えられる部分もあるのだなと思ったことを覚えています。<br /><br />

                            <CardContent>
                                <TipsAndUpdatesIcon /> 戦略コンサルティングファームであるBoston Consulting Groupの公開資料のリンクを下記にご紹介します。P27のスライドを見ると、スライドの矢羽には枠線がなく、丸い矢印にも枠線がないことで、洗練された印象です。
                                <blockquote>
                                    <Typography variant="body2" color="text.secondary">
                                        出典:METI <a href="https://www.meti.go.jp/meti_lib/report/2020FY/000410.pdf" target="_blank" rel="noopener noreferrer"> meti.go.jp </a> (p27) - Boston Consulting Group
                                    </Typography>
                                </blockquote>
                            </CardContent>

                        </Typography>
                    </CardContent>


                    <Divider id="4" style={{ margin: '40px 0' }} />
                    <CardContent>
                        <Typography variant="h4" style={{ fontSize: '30px' }}>最後に一言</Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5">
                            デザインと一言にいうと感性的なものであったり個人の趣味が入りやすい領域ですが、プレゼンテーションにおいては見た目を綺麗にするだけじゃない、大事な要素だということがわかっていただけたかと思います。<br /><br />

                            プレゼンテーションの目的は何かを説明することですが、強調する部分を色使いを含むデザインによってコントロールすることで、伝えるべきメッセージを着実に届けることができます。<br /><br />

                            本記事を参考にし、「見た目も洗練されたプレゼンを作るとともに、メッセージ性の高いプレゼンテーションの作成」目指していきましょう。
                        </Typography>
                    </CardContent>

                    <Divider style={{ margin: '20px 0' }} />
                    <CardContent>
                        <A8AdEFEnglish />
                    </CardContent>
                    <Button
                        variant="text"
                        size="small"
                        endIcon={<ShareIcon />}
                        style={{ color: 'black' }}
                        onClick={() => handleImageClick("/")}
                    >
                        他のプレゼンテーションスキルを学ぶ（記事一覧へ）
                    </Button>
                </Card>
            </Box>
        </div>
    );
};

export default Article;
